"use client";

import { useState, useEffect } from "react";
import APP_CONFIG from "./Config";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition'

const SearchBar = ({ searchQuery, setSearchQuery }) => {

  const [manualText, setManualText] = useState('');

  const placeholders = [
    "Search for item master generation...",
    "Find how to generate a BOM...",
    "Learn to release a BOM...",
    "Check PO pending report...",
    "Generate a manual purchase order...",
    "Convert quotation to sales order...",
    "Explore stock details and reports...",
    "Issue materials against BOM...",
    "Verify and authenticate POs...",
    "Authenticate MRN against BOM...",
    "Track item presence in projects...",
    "Raise a service complaint...",
  ];

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  const handleStart = () => {
    resetTranscript(); 
    SpeechRecognition.startListening({ continuous: false, language: 'en-US' });
  };

  const handleInputChange = (e) => {
    setManualText(e.target.value);
  };

  

  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  useEffect(() => {
    if (listening) return; 
  
    const interval = setInterval(() => {
      setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
    }, 3000);
  
    return () => clearInterval(interval);
  }, [listening]);
  

  useEffect(() => {
    if (transcript) {
      setSearchQuery(transcript);
    }
  }, [transcript]);

  const handleSearch = ()=>{
    if(searchQuery.trim().length > 0){
      fetch(APP_CONFIG.BACKEND_URL+'searchTerm',{
        method:'POST',
        headers:{
          'Content-Type':'application/json',
        },
        body: JSON.stringify({
          ProductId:1, 
          ModuleId:1, 
          SearchTerm: searchQuery.trim().toLowerCase()
        }),
      }).catch(() => {
        console.error("Error fetching search results");
      });
    }
  }

  useEffect(()=>{
    const debounceTimer = setTimeout(()=>{
      if(searchQuery.trim().toLowerCase()){
        handleSearch();
      }
    },1500);

    return () => clearTimeout(debounceTimer);
  },[searchQuery])

  if (!browserSupportsSpeechRecognition) {
    return <span>🛑 Your browser doesn't support speech recognition.</span>;
  }

  return (
    <div className="px-3 my-3">
      <form onSubmit={(e) => e.preventDefault()} className="position-relative">
      <div className="input-group form-control rounded-pill py-2 shadow-sm">
      <span className="input-group-text bg-white border-0 ps-3" style={{fontSize: "1.25rem",fontWeight:"800",fontStyle:"bold"}}>
          <i className="bi bi-search"></i>
        </span>
        <input
          type="text"
          className="form-control border-0"
          placeholder={listening ? "🎤 Listening..." : placeholders[placeholderIndex]}
          value={searchQuery}
          onChange={(e)=>setSearchQuery(e.target.value)}
          style={{
            fontSize: "1rem",
            transition: "placeholder 0.3s ease-in-out",
          }}
        />
        <button className="btn btn-light rounded-pill" type="button" onClick={handleStart} style={{border:"none"}}>
          <span className="input-group-text border-0 btn btn-light rounded-pill" >
          <i className="bi bi-mic-fill"></i>
          </span>
        </button>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
